import React from 'react';
// Import react-icons for exact matches
import { 
  LuCamera,
  LuStar,
  LuShoppingCart,
  LuMapPin,
  LuMessageCircle,
  LuArrowLeft,
  LuPlus
} from 'react-icons/lu';

export const StoreHeader = ({ 
  sellerProfile, 
  sellerUnread, 
  onNavigateToProfile, 
  onNavigateToChats,
  isMobile = false 
}) => {
  if (isMobile) {
    return (
      <div className="relative">
        {/* Mobile Cover Photo */}
        <div 
          className="w-full h-[150px] bg-cover bg-center relative"
          style={{
            backgroundImage: `url(${sellerProfile?.store_cover_picture_url || 'https://via.placeholder.com/1200x300/f5f5f5/cccccc?text=Store+Cover+Photo'})`,
            backgroundSize: 'cover'
          }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/30" />
          
          {/* Mobile Header with Back Button */}
          <div className="absolute top-0 left-0 right-0 p-3">
            <div className="flex items-center justify-between">
              <button 
                onClick={onNavigateToChats}
                className="relative flex items-center justify-center w-8 h-8 bg-black/50 rounded-full"
              >
                <LuMessageCircle className="w-5 h-5 text-white" />
                {sellerUnread > 0 && (
                  <div className="absolute -top-1 -right-1 bg-orange-600 rounded-full min-w-[16px] h-[16px] flex items-center justify-center">
                    <span className="text-[9px] text-white font-bold">
                      {sellerUnread > 9 ? '9+' : sellerUnread}
                    </span>
                  </div>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Store Info */}
        <div className="px-4 -mt-8 relative">
          <div className="flex items-start">
            {/* Logo Container */}
            <button 
              className="relative mr-4"
              onClick={onNavigateToProfile}
            >
              <img
                src={sellerProfile?.store_logo_url || 'https://via.placeholder.com/100x100/f5f5f5/cccccc?text=LOGO'}
                alt="Store logo"
                className="w-16 h-16 rounded-lg border-[3px] border-white object-cover shadow-md"
              />
              <div className="absolute -bottom-1 -right-1 bg-orange-600 w-5 h-5 rounded-full flex items-center justify-center border-2 border-white">
                <LuCamera className="w-2.5 h-2.5 text-white" />
              </div>
            </button>
            
            {/* Store Details - Mobile */}
            <div className="flex-1 pt-2">
            {/* Store Info Card */}<br />
            <div className="flex-1 pt-2">
              <h1 className="text-lg font-bold text-gray-900 mb-1 truncate">
                {sellerProfile?.store_name || 'My Store'}
              </h1>
              <p className="text-xs text-gray-600 mb-2 line-clamp-2 leading-relaxed">
                {sellerProfile?.store_description || 'Add a store description to attract more customers'}
              </p>
              
              <div className="flex flex-wrap gap-2">
                {/* Rating */}
                <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded">
                  <LuStar className="w-3 h-3 text-yellow-500" />
                  <span className="text-xs font-medium">
                    {sellerProfile?.rating_avg || '0.0'}
                  </span>
                </div>
                
                {/* Sales */}
                <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded">
                  <LuShoppingCart className="w-3 h-3 text-orange-600" />
                  <span className="text-xs font-medium">
                    {sellerProfile?.total_sales || 0} sales
                  </span>
                </div>
                
                {/* Location */}
                <div className="flex items-center gap-1 bg-gray-100 px-2 py-1 rounded">
                  <LuMapPin className="w-3 h-3 text-gray-500" />
                  <span className="text-xs font-medium truncate max-w-[80px]">
                    {sellerProfile?.store_location || 'Add location'}
                  </span>
                </div>
              </div>
            </div> 
          </div>

          </div>
          
          {/* Mobile Action Buttons */}
          <div className="flex gap-2 mt-4">
            <button
              onClick={() => window.location.href = '/store/listings/create-listing'}
              className="flex-1 bg-orange-600 text-white py-2 rounded-lg font-medium flex items-center justify-center gap-2"
            >
              <LuPlus className="w-4 h-4" />
              New Listing
            </button>
            
            <button
              onClick={onNavigateToProfile}
              className="px-4 py-2 border border-gray-300 rounded-lg font-medium"
            >
              Edit Store
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Desktop Version (original)
  return (
    <div className="h-[200px] relative">
      {/* Cover Photo with Overlay */}
      <div 
        className="w-full h-full bg-cover bg-center relative"
        style={{
          backgroundImage: `url(${sellerProfile?.store_cover_picture_url || 'https://via.placeholder.com/1200x300/f5f5f5/cccccc?text=Store+Cover+Photo'})`,
          backgroundSize: 'cover'
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/30" />
        
        {/* Store Info - positioned exactly like RN */}
        <div className="absolute bottom-0 left-0 right-0 p-5 pb-4">
          <div className="flex items-end">
            {/* Logo Container */}
            <button 
              className="relative mr-4"
              onClick={onNavigateToProfile}
            >
              <img
                src={sellerProfile?.store_logo_url || 'https://via.placeholder.com/100x100/f5f5f5/cccccc?text=LOGO'}
                alt="Store logo"
                className="w-20 h-20 rounded-lg border-[3px] border-white object-cover"
              />
              <div className="absolute -bottom-1 -right-1 bg-orange-600 w-6 h-6 rounded-full flex items-center justify-center border-2 border-white">
                <LuCamera className="w-3 h-3 text-white" />
              </div>
            </button>
            
            {/* Store Details */}
            <div className="flex-1 mr-4">
              <h1 className="text-xl font-bold text-white mb-1 truncate">
                {sellerProfile?.store_name || 'My Store'}
              </h1>
              <p className="text-sm text-white/90 mb-2 line-clamp-2 leading-relaxed">
                {sellerProfile?.store_description || 'Add a store description to attract more customers'}
              </p>
              <div className="flex gap-3">
                {/* Rating */}
                <div className="flex items-center gap-1">
                  <LuStar className="w-3.5 h-3.5 text-yellow-400" />
                  <span className="text-xs text-white/90 font-medium">
                    {sellerProfile?.rating_avg || '0.0'}
                  </span>
                </div>
                
                {/* Sales */}
                <div className="flex items-center gap-1">
                  <LuShoppingCart className="w-3.5 h-3.5 text-orange-600" />
                  <span className="text-xs text-white/90 font-medium">
                    {sellerProfile?.total_sales || 0} sales
                  </span>
                </div>
                
                {/* Location */}
                <div className="flex items-center gap-1">
                  <LuMapPin className="w-3.5 h-3.5 text-gray-400" />
                  <span className="text-xs text-white/90 font-medium truncate max-w-[100px]">
                    {sellerProfile?.store_location || 'Add location'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Notification/Chat Icon - positioned exactly like RN */}
        <button 
          className="absolute top-4 right-4 p-2"
          onClick={onNavigateToChats}
        >
          <div className="relative">
            <LuMessageCircle className="w-6 h-6 text-white" />
            {sellerUnread > 0 && (
              <div className="absolute -top-1 -right-1 bg-orange-600 rounded-full min-w-[18px] h-[18px] flex items-center justify-center">
                <span className="text-[10px] text-white font-bold px-1">
                  {sellerUnread > 99 ? '99+' : sellerUnread}
                </span>
              </div>
            )}
          </div>
        </button>
      </div>
    </div>
  );
};

export default StoreHeader;